import LinkCard, { type LinkCardProps } from './LinkCard';
import WhyArchiProCard, { type WhyArchiProCardProps } from './WhyArchiProCard';
export const BottomLinkSection = ({
    whyArchiPro,
    bottomLink,
    openLogin,
    overriteTracking,
}: {
    whyArchiPro?: WhyArchiProCardProps[];
    bottomLink?: LinkCardProps[];
    openLogin: (url: string) => void;
    overriteTracking?: (event: string, sectionName: string) => void;
}) => {
    return (
        <>
            {whyArchiPro && whyArchiPro.length > 0 && (
                <section className="w-full qhd:mx-auto qhd:max-w-[1920px]">
                    <div className="flex flex-col gap-10 px-6 md:px-12">
                        <h3 className="text-lg font-medium leading-[1.3] tracking-[0.025rem]">
                            <span>Why ArchiPro?</span>
                        </h3>

                        <div className="grid grid-cols-1 gap-5 md:grid-cols-4">
                            {whyArchiPro.map((card, index) => (
                                <WhyArchiProCard
                                    key={`why_archipro_card_${card.title}_${index}`}
                                    title={card.title}
                                    description={card.description}
                                    to={card.to}
                                    buttonText={card.buttonText}
                                    icon={card.icon}
                                />
                            ))}
                        </div>
                    </div>
                </section>
            )}
            {bottomLink && bottomLink.length > 0 && (
                <section className="w-full qhd:mx-auto qhd:max-w-[1920px]">
                    <div className="flex flex-col gap-[6rem] px-6 md:px-12">
                        <div className="flex w-full flex-col flex-wrap items-stretch justify-center gap-6 md:flex-row md:gap-5">
                            {bottomLink.map((card, index) => (
                                <LinkCard
                                    key={`link_card_${card.title}_${card.variant}_${index}`}
                                    title={card.title}
                                    description={card.description}
                                    variant={card.variant}
                                    to={card.to}
                                    onClick={(e: MouseEvent) => {
                                        if (card.to === '/login') {
                                            openLogin(card.to);
                                            e.preventDefault();
                                        }
                                        overriteTracking?.(
                                            index === 0
                                                ? 'StartProjectClick'
                                                : 'BecomeProClick',
                                            'LandingPageCards',
                                        );
                                    }}
                                />
                            ))}
                        </div>
                    </div>
                </section>
            )}
        </>
    );
};
